<template>
  <div class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <!-- 画像を拡大表示-->
    <dd-plan-uplode-img-view
    ref="SketchUplodeImgViewModalRef"
    @sketchUploadImgView="sketchUploadImgView"
    />
    <!-- 画像一覧を表示-->
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
        <button @click="sketchUploadImgAllDL(sketchId)" v-show="false">一括ダウンロード</button>
      </div>
      <div class="data-area">
        <div v-for="(sketchUplode, index) in SketchUplodeList" :key="index">
          <img class="sketch-uploade-img" :src="getImage(sketchUplode.sketchUploadImg)" @click="sketchUploadImgView(sketchUplode.sketchUploadImg)">
        </div>
      </div>
      <div class="modal-footer">
        <button class="main_btn" @click="close()">閉じる</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import * as Api from '../../../utils/Api'
import * as App from '../../../utils/App'
import SketchUplodeImgViewModal from './SketchUplodeImgView'

export default {
  name: 'SketchUplodeImgList',
  components: {
    'dd-plan-uplode-img-view': SketchUplodeImgViewModal
  },
  data () {
    return {
      modalShown: false,
      sketchId: '',
      SketchUplodeList: []
    }
  },
  watch: {
  },
  methods: {
    showModal: function (sketchId) {
      this.sketchId = sketchId
      axios.post(API_URL.LIST + '/sketchUploadImgList/' + sketchId)
        .then(response => {
          this.SketchUplodeList = response.data
        }).catch(error => {
          this.modalShown = false
          Api.handleError(error)
        })
        .finally(() => {
          this.onLoad = false
        })
      this.modalShown = true
    },
    close: function () {
      this.modalShown = false
    },
    getImage: function (image) {
      return App.getContentsSkupResource(image)
    },
    sketchUploadImgView: function (image) {
      this.$refs.SketchUplodeImgViewModalRef.showModal(image)
    },
    sketchUploadImgAllDL: function (sketchId) {
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-main {
  max-width: 700px;
}
.data-area {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
}
.modal-main{
  max-height: 100%;
}
.sketch-uploade-img{
  width: 200px;
  height: 200px;
  margin: 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/SketchUplodeImgList.vue